export default {
	apiUrl: process.env.REACT_APP_API_URL,
	laravelUrl: process.env.REACT_APP_REPORT_SERVICE_URL,
	jwtToken: process.env.REACT_APP_JWT,
	version: process.env.REACT_APP_VERSION
}